<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="760"
      style="overflow: hidden !important"
    >
      <template v-slot:activator="{ on }">
        <v-btn color="primary" v-on="on" v-if="typeModal === 'add'">
          <v-icon class="mr-2">mdi-plus</v-icon>
          Add Shopper Activities
        </v-btn>
        <v-btn color="primary" v-on="on" v-else small class="mt-1">
          <v-icon color="white">
            mdi-square-edit-outline
          </v-icon>
          Evaluation
        </v-btn>
      </template>

      <v-card>
        <ValidationObserver ref="roiGimmick">
          <v-card-title class="primary white--text text-uppercase">
            {{
              typeModal === 'add'
                ? 'ADD ROI GIMMICK'
                : 'ACTIVITIES ' + dataGimmick.name
            }}
          </v-card-title>

          <v-divider></v-divider>
          <VuePerfectScrollbar
            class="drawer-menu--scroll-dialog-roi"
            :settings="scrollSettings"
          >
            <v-card-text class="black--text">
              <v-row>
                <v-col>
                  <v-row dense>
                    <v-col cols="12" class="py-0">
                      <ValidationProvider
                        name="IO Reference"
                        rules="required"
                        v-slot="{ errors }"
                        class="pa-0"
                      >
                        <label class="darkblue--text">
                          IO Reference
                        </label>
                        <v-card
                          v-if="typeModal === 'evaluation'"
                          outlined
                          class="pa-2 mb-5 border-field"
                        >
                          {{ dataGimmick.internalOrder.io_number }}
                        </v-card>
                        <v-autocomplete
                          v-else
                          single-line
                          outlined
                          dense
                          :items="itemsIO"
                          item-text="io_number"
                          return-object
                          :error-messages="errors"
                          placeholder="IO Reference"
                          id="IO Reference"
                          v-model="io_number"
                          :disabled="isDisabled"
                        ></v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="py-0">
                      <label class="darkblue--text">
                        IO Description
                      </label>
                      <v-card outlined class="pa-2 mb-5 border-field">
                        {{
                          typeModal === 'evaluation'
                            ? dataGimmick.internalOrder.activity_desc
                            : io_number.activity_desc
                            ? io_number.activity_desc
                            : 'IO Description'
                        }}
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="py-0">
                      <label class="darkblue--text">
                        Amount IO
                      </label>
                      <v-card outlined class="pa-2 mb-5 border-field">
                        {{
                          typeModal === 'evaluation'
                            ? idr(dataGimmick.amount)
                            : io_number.ioAmount
                            ? idr(io_number.ioAmount[0].total_amount)
                            : 0
                        }}
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="py-0">
                      <ValidationProvider
                        name="Name"
                        rules="required"
                        v-slot="{ errors }"
                        class="pa-0"
                      >
                        <label class="darkblue--text">
                          Name
                        </label>
                        <!-- <v-card
                          v-if="typeModal === 'evaluation'"
                          outlined
                          class="pa-2 mb-5 text-capitalize border-field"
                        >
                          {{ dataGimmick.name }}
                        </v-card> -->
                        <v-text-field
                          single-line
                          outlined
                          dense
                          :error-messages="errors"
                          placeholder="Name"
                          id="name-gimmick"
                          v-model="name"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="py-0">
                      <ValidationProvider
                        name="Redemption Amount"
                        rules="required"
                        v-slot="{ errors }"
                        class="pa-0"
                      >
                        <label class="darkblue--text">
                          Redemption Amount
                        </label>
                        <!-- <v-card
                          v-if="typeModal === 'evaluation'"
                          outlined
                          class="pa-2 mb-5 border-field"
                        >
                          {{ idr(dataGimmick.redemption_amount) }}
                        </v-card> -->
                        <v-currency-field
                          single-line
                          outlined
                          dense
                          :error-messages="errors"
                          placeholder="Redemption Amount"
                          id="Redemption-Amount"
                          v-model="redemption_amount"
                        />
                        <!-- <v-text-field
                          v-else
                          single-line
                          outlined
                          dense
                          :error-messages="errors"
                          placeholder="Redemption Amount"
                          id="Redemption-Amount"
                          v-model="redemption_amount"
                          type="number"
                          :disabled="isDisabled"
                        ></v-text-field> -->
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="6" class="py-0">
                      <ValidationProvider
                        name="Gimmick Amount"
                        rules="required"
                        v-slot="{ errors }"
                        class="pa-0"
                      >
                        <label class="darkblue--text">
                          Gimmick Amount
                        </label>
                        <!-- <v-card
                          v-if="typeModal === 'evaluation'"
                          outlined
                          class="pa-2 mb-5 border-field"
                        >
                          {{ idr(dataGimmick.quantity_order) }}
                        </v-card> -->
                        <v-currency-field
                          single-line
                          outlined
                          dense
                          :error-messages="errors"
                          placeholder="Gimmick Amount"
                          id="Gimmick-Amount"
                          v-model="quantity_order"
                        />
                        <!-- <v-text-field
                          v-else
                          single-line
                          outlined
                          dense
                          :error-messages="errors"
                          placeholder="Gimmick Amount"
                          id="Gimmick-Amount"
                          v-model="quantity_order"
                          type="number"
                          :disabled="isDisabled"
                        ></v-text-field> -->
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="6" class="py-0">
                      <ValidationProvider
                        name="Unit"
                        rules="required"
                        v-slot="{ errors }"
                        class="pa-0"
                      >
                        <label class="darkblue--text">
                          Unit
                        </label>
                        <!-- <v-card
                          v-if="typeModal === 'evaluation'"
                          outlined
                          class="pa-2 mb-5 border-field"
                        >
                          {{ dataGimmick.unit }}
                        </v-card> -->
                        <v-autocomplete
                          single-line
                          outlined
                          dense
                          :items="itemsUnit.result"
                          item-text="unit"
                          item-value="unit"
                          :error-messages="errors"
                          placeholder="Quantity Unit"
                          id="Quantity-Unit"
                          v-model="unit"
                        ></v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="py-0">
                      <label class="darkblue--text">
                        Cost of Gimmick (Price/Unit)
                      </label>
                      <v-card outlined class="pa-2 mb-5 border-field">
                        {{
                          isNaN(price) ||
                          price == Number.POSITIVE_INFINITY ||
                          price == Number.NEGATIVE_INFINITY
                            ? 'Price'
                            : idr(price)
                        }}
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="py-0">
                      <label class="darkblue--text">
                        Amount of Investment
                      </label>
                      <v-card outlined class="pa-2 mb-5 border-field">
                        {{ idr(amount) }}
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col>
                  <v-row dense>
                    <v-col cols="12" class="py-0">
                      <label class="darkblue--text">
                        Redemption Absolute
                      </label>
                      <v-card outlined class="pa-2 mb-5 border-field">
                        {{ idr(redemption_abs) }}
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="py-0">
                      <label class="darkblue--text">
                        Redemption Rate
                      </label>
                      <v-card outlined class="pa-2 mb-5 border-field">
                        {{
                          isNaN(redemption_rate) ||
                          redemption_rate == Number.POSITIVE_INFINITY ||
                          redemption_rate == Number.NEGATIVE_INFINITY
                            ? 'Redemption Rate'
                            : redemption_rate
                        }}
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="py-0">
                      <ValidationProvider
                        name="Cost of Gimmick"
                        rules="required"
                        v-slot="{ errors }"
                        class="pa-0"
                      >
                        <label class="darkblue--text">
                          Cost of Gimmick
                        </label>
                        <!-- <v-card
                          v-if="typeModal === 'evaluation'"
                          outlined
                          class="pa-2 mb-5 border-field"
                        >
                          {{ idr(dataGimmick.gimmick_cost) }}
                        </v-card> -->
                        <v-currency-field
                          single-line
                          outlined
                          dense
                          :error-messages="errors"
                          placeholder="Cost of Gimmick"
                          id="Cost-Gimmick"
                          v-model="cost_gimmick"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="py-0">
                      <ValidationProvider
                        name="Baseline"
                        rules="required"
                        v-slot="{ errors }"
                        class="pa-0"
                      >
                        <label class="darkblue--text">
                          Baseline Sales 2 Week
                        </label>
                        <v-currency-field
                          single-line
                          outlined
                          dense
                          :error-messages="errors"
                          placeholder="Baseline"
                          id="Baseline"
                          v-model="baseline"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="py-0">
                      <ValidationProvider
                        name="Sales During Activity"
                        rules="required"
                        v-slot="{ errors }"
                        class="pa-0"
                      >
                        <label class="darkblue--text">
                          Sales During Activity 2 Week
                        </label>
                        <v-currency-field
                          single-line
                          outlined
                          dense
                          :error-messages="errors"
                          placeholder="Sales During Activity 2 Week"
                          id="sales"
                          v-model="sales_activity"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="py-0">
                      <label class="darkblue--text">
                        Sales Uplift
                      </label>
                      <v-card outlined class="pa-2 mb-5 border-field">
                        {{ idr(sales_uplift) }}
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="py-0">
                      <label class="darkblue--text">
                        ROI
                      </label>
                      <v-card outlined class="pa-2 mb-5 border-field">
                        <v-row class="px-3">
                          {{
                            isNaN(roi) ||
                            roi == Number.POSITIVE_INFINITY ||
                            roi == Number.NEGATIVE_INFINITY
                              ? 'ROI'
                              : roi
                          }}
                          <v-spacer></v-spacer>
                          <label>%</label>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </VuePerfectScrollbar>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#bd1e19" dark @click="dialog = false">
              Cancel
            </v-btn>
            <v-btn color="primary" @click="save" class="mr-2">
              Submit
            </v-btn>
          </v-card-actions>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
// import isFilter from '../../mixins/filter';
import ProgressDialog from '../../components/progress_dialog';
import Swal from 'sweetalert2';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: { 'progress-dialog': ProgressDialog, VuePerfectScrollbar },
  name: 'DialogAddRoi',
  props: {
    code: {
      type: String,
      require: false
    },
    typeModal: {
      type: String,
      require: true
    },
    dataGimmick: {
      type: Object,
      require: false
    }
  },
  data() {
    return {
      scrollSettings: {
        maxScrollbarLength: 160
      },
      progressDialogLoading: false,
      dialog: false,
      io_number: {},
      name: '',
      quantity_order: 0,
      redemption_amount: 0,
      cost_gimmick: 0,
      baseline: 0,
      sales_activity: 0,
      unit: '',
      itemsUnit: [],
      timeout: null,
      itemsIO: []
    };
  },
  async mounted() {
    await this.getUnit();
    await this.getIO();
    if (this.typeModal === 'evaluation') {
      this.baseline = this.dataGimmick.baseline_evaluation
        ? this.dataGimmick.baseline_evaluation
        : this.dataGimmick.baseline;
      this.sales_activity = this.dataGimmick.sales_activity_evaluation
        ? this.dataGimmick.sales_activity_evaluation
        : this.dataGimmick.sales_activity;
      this.redemption_amount = this.dataGimmick.redemption_amount_evaluation
        ? this.dataGimmick.redemption_amount_evaluation
        : this.dataGimmick.redemption_amount;
      this.quantity_order = this.dataGimmick.quantity_order_evaluation
        ? this.dataGimmick.quantity_order_evaluation
        : this.dataGimmick.quantity_order;
      this.unit = this.dataGimmick.unit_evaluation
        ? this.dataGimmick.unit_evaluation
        : this.dataGimmick.unit;
      this.cost_gimmick = this.dataGimmick.gimmick_cost_evaluation
        ? this.dataGimmick.gimmick_cost_evaluation
        : this.dataGimmick.gimmick_cost;
      this.name = this.dataGimmick.name_evaluation
        ? this.dataGimmick.name_evaluation
        : this.dataGimmick.name;
    }
  },
  computed: {
    isDisabled() {
      return this.typeModal === 'evaluation' ? true : false;
    },
    amount_io() {
      return this.io_number.ioAmount
        ? this.io_number.ioAmount[0].total_amount
        : 0;
    },
    price() {
      return (this.cost_gimmick / this.quantity_order).toFixed(1);
    },
    redemption_rate() {
      return (this.redemption_amount / this.quantity_order).toFixed(1);
    },
    roi() {
      return (((this.sales_uplift - this.amount) / this.amount) * 100).toFixed(
        1
      );
    },
    redemption_abs() {
      let abs = (this.price * this.redemption_amount).toFixed(1);
      return isNaN(abs) ? 0 : abs;
    },
    sales_uplift() {
      return (this.sales_activity - this.baseline).toFixed(1);
    },
    amount() {
      let amt = (this.price * Number(this.quantity_order)).toFixed(1);
      return isNaN(amt) ? 0 : amt;
    }
  },
  methods: {
    getUnit() {
      this.$store
        .dispatch('unit/getAll', {
          limit: 100
        })
        .then(data => {
          if (data.code === 200) {
            this.itemsUnit = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getIO() {
      this.$store
        .dispatch('mroi/getIO', {
          io_number: ''
        })
        .then(data => {
          if (data.code === 200) {
            this.itemsIO = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    async save() {
      if (this.typeModal === 'evaluation') {
        this.progressDialogLoading = true;
        const params = {
          id: this.dataGimmick.id,
          price_evaluation: this.price,
          redemption_amount_evaluation: this.redemption_amount,
          redemption_abs_evaluation: this.redemption_abs,
          redemption_rate_evaluation: this.redemption_rate,
          amount_evaluation: this.amount,
          quantity_order_evaluation: this.quantity_order,
          unit_evaluation: this.unit,
          gimmick_cost_evaluation: this.cost_gimmick,
          baseline_evaluation: this.baseline,
          sales_activity_evaluation: this.sales_activity,
          sales_uplift_evaluation: this.sales_uplift,
          roi_evaluate: this.roi,
          name_evaluation: this.name
        };
        this.$store
          .dispatch('mroi/evaluate', params)
          .then(data => {
            this.progressDialogLoading = false;
            // this.loading = false;
            if (data.code === 200) {
              this.dialog = false;
              Swal.fire({
                title: 'Success!',
                text: `${data.message.text_en}`,
                type: 'success',
                showCancelButton: false,
                confirmButtonText: 'OK'
              }).then(result => {
                if (result.value) {
                  // this.closeDialog();
                  this.$emit('getlistData');
                }
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        if (this.quantity_order < 0) {
          Swal.fire('Failed!', 'Minimum Quantity Order is 1', 'error');
        } else {
          const validated = await this.$refs.roiGimmick.validate();
          if (validated) {
            this.progressDialogLoading = true;
            const params = {
              io_code: this.io_number.code,
              name: this.name,
              amount: this.amount,
              quantity_order: this.quantity_order,
              unit: this.unit,
              price: this.price,
              redemption_amount: this.redemption_amount,
              redemption_abs: this.redemption_abs,
              redemption_rate: this.redemption_rate,
              gimmick_cost: this.cost_gimmick,
              baseline: this.baseline,
              sales_activity: this.sales_activity,
              sales_uplift: this.sales_uplift,
              roi: this.roi
            };
            this.$store
              .dispatch('onePager/createGimmick', params)
              .then(data => {
                this.progressDialogLoading = false;
                // this.loading = false;
                if (data.code === 200) {
                  this.dialog = false;
                  Swal.fire({
                    title: 'Success!',
                    text: `${data.message.text_en}`,
                    type: 'success',
                    showCancelButton: false,
                    confirmButtonText: 'OK'
                  }).then(result => {
                    if (result.value) {
                      // this.closeDialog();
                      this.io_number = {};
                      this.name = '';
                      this.quantity_order = 0;
                      this.redemption_amount = 0;
                      this.baseline = 0;
                      this.sales_activity = 0;
                      this.unit = '';
                      this.cost_gimmick = 0;
                      requestAnimationFrame(() => {
                        this.$refs.roiGimmick.reset();
                      });
                      this.$emit('getlistData');
                    }
                  });
                } else {
                  Swal.fire(
                    'Failed!',
                    data.response.data.message.text_en,
                    'error'
                  );
                }
              })
              .catch(err => {
                Swal.fire(
                  'Failed!',
                  err.response.data.message.text_en,
                  'error'
                );
                this.progressDialogLoading = false;
                this.loading = false;
              });
          }
        }
      }
    },
    closeDialog() {
      this.io_number = {};
      this.name = '';
      this.quantity_order = 0;
      this.redemption_amount = 0;
      this.baseline = 0;
      this.sales_activity = 0;
      this.unit = '';
      this.cost_gimmick = 0;
      requestAnimationFrame(() => {
        this.$refs.roiGimmick.reset();
      });
    },
    amountCheck() {
      let param = {
        io_code: this.io_number.code ? this.io_number.code : '',
        roi_amount: this.amount
      };
      this.$store
        .dispatch('mroi/amountCheck', param)
        .then(data => {
          if (data.code === 200) {
            // console.log(data);
            console.log(data);
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    }
  }
};
</script>

<style>
.drawer-menu--scroll-dialog-roi {
  max-height: 500px;
  overflow: auto;
}
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100% !important;
}
</style>
